
export class SearchCriteria {
  public static fromCriteria(searchCriteria: {[key: string]: any}): SearchCriteria {
    return new SearchCriteria(searchCriteria)
  }

  private constructor(private _searchCriteria: {[key: string]: any}) {}

  public isEmpty(): boolean {
    return this._numberOfCriteria() === 0
  }

  public isIdOnly(): boolean {
    return this._searchCriteria.hasOwnProperty('id') && this._numberOfCriteria() === 1
  }

  public isFilter(): boolean {
    return this._numberOfCriteria() >= 1 && !this._searchCriteria.hasOwnProperty('id')
  }

  public toObject() {
    return JSON.parse(JSON.stringify(this._searchCriteria))
  }

  public getSearchCriteriaType() {
    if (this.isEmpty()) {
      return 'all'
    } else if (this.isIdOnly()) {
      return 'id'
    } else {
      return 'filter'
    }
  }

  private _numberOfCriteria() {
    return Object.keys(this._searchCriteria).length
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/search-criteria/search-criteria.ts